import React, { Component } from "react";
import { MSection, BoxDanger } from "components/misc";
import { dateHelper, stringHelper } from "libs";
import { LESSONTRAINING_MODE, ROUTES } from "const";

export class CourseLessonSectionGroupTable extends Component {

  goToLesson = (lesson) => {
    const { rCode } = this.props;
    if (lesson.lessonType === "live") {
      window.location = `${ROUTES.COURSE_LESSONLIVE_DETAIL}/${rCode}/${lesson.id}`;
    } else if (lesson.lessonType === "onsite") {
      window.location = `${ROUTES.COURSE_LESSONONSITE_DETAIL}/${rCode}/${lesson.id}`;
    } else if (lesson.lessonType === "training") {
      if (lesson.mode === LESSONTRAINING_MODE.ATTIVITA) {
        window.location = `${ROUTES.COURSE_LESSON_ACTIVITY}/training/${lesson.location}/${lesson.id}/${rCode}`;
      } else {
        window.location = `${ROUTES.COURSE_LESSONTRAINING_DETAIL}/${rCode}/${lesson.id}`;
      }
    }
  };

  render() {
    const {
      lessons,
      sections,
      sectionsGroup,
      userCourse,
      lessonCreditRecognition,
    } = this.props;

    if (lessons && lessons.length > 0 && sections && sections.length > 0
      && sectionsGroup && sectionsGroup.length > 0
    ) {

      const table = sectionsGroup.map((group) => {

        const groupPercent = group.percent>1 ? 1 : group.percent;

        const headerGroup = (
          <MSection className="m-2">
            <h3>{group.title}</h3>
            {(group.totalMinutes && group.totalMinutes > 0) ? (
              <><h5>Percentuale di frequenza: {stringHelper.formatPercentage(groupPercent)}
                {(group.lastUpdate) && <small> (ultimo aggiornamento {dateHelper.toITDateTime(group.lastUpdate)})</small>}
              </h5></>) : <></>}
          </MSection>
        );

        // foreach section of sessionGroup
        const sectionIds = group.idSections.split(',');

        const sectionElements = sectionIds.map((sectionId) => {

          // find the section
          const section = sections.find((s) => s.id === sectionId);

          const sectionLessons = lessons.filter(
            (lesson) => lesson.section === section.code
          );

          const isATD = (section.code === "ATD") ? true : false;
          const isTirocinio = (section.code === "ATD" || section.code === "ATI") ? true : false;

          if (sectionLessons.length > 0) {
            return (
              <div key={section.id}>
                <MSection className="m-2">
                  <h4>
                    {section.title} [{section.code}]{" "}
                  </h4>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        {isATD ? <>
                          <th scope="col" colSpan={3}></th> </>
                          : <><th scope="col">Data</th>
                            <th scope="col">Ora Inizio</th>
                            <th scope="col">Insegnamento</th></>}

                        {!isTirocinio && <th scope="col">Docente</th>}
                        {!isTirocinio && <th scope="col">Tipo</th>}
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {sectionLessons.map((lesson, i) => {
                        let checkLessonCreditRecognition = [];
                        if (
                          lesson.lessonType === "onsite" &&
                          lessonCreditRecognition.length > 0
                        ) {
                          checkLessonCreditRecognition =
                            lessonCreditRecognition.filter((item) => {
                              return (
                                item.lessonId === lesson.id &&
                                item.registrationCode === this.props.rCode
                              );
                            });
                        }

                        let isRecognized = false;
                        // verify the creditRecognition
                        if (
                          checkLessonCreditRecognition.length > 0 ||
                          (lesson.creditRecognition &&
                            userCourse.creditRecognition &&
                            lesson.creditRecognition.includes(
                              userCourse.creditRecognition
                            ))
                        ) {
                          isRecognized = true;
                        }

                        return (
                          <tr key={i}>
                            <td>
                              {lesson.date
                                ? dateHelper.toITDate(lesson.date)
                                : ""}
                            </td>
                            <td>
                              {lesson.hourStart
                                ? dateHelper.toShortTime(lesson.hourStart)
                                : ""}
                            </td>
                            <td>
                              {lesson.subject}
                              {isRecognized && (
                                <>
                                  <br />
                                  <span className="badge badge-secondary m-1">
                                    Attività riconosciuta e calcolata nella percentuale di presenza
                                  </span>
                                </>
                              )}
                            </td>
                            {!isTirocinio && <td>{lesson.teacher}</td>}
                            {!isTirocinio && (
                              <>
                                <td>
                                  {lesson.lessonType === "live" &&
                                    "Lezione telematica"}
                                  {lesson.lessonType === "onsite" &&
                                    "Lezione in presenza"}
                                  {lesson.lessonType === "training" &&
                                    "Tirocinio indiretto"}
                                </td>
                                <td>
                                  {lesson.lessonType === "training" &&
                                    lesson.mode === LESSONTRAINING_MODE.ATTIVITA &&
                                    !lesson.location ? (
                                    ""
                                  ) : (
                                    <button
                                      className="btn btn-outline-primary"
                                      onClick={() => this.goToLesson(lesson)}
                                    >
                                      Dettagli
                                    </button>
                                  )}
                                </td>
                              </>)}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </MSection>
              </div>
            );
          } else
            return null;
        });

        if (sectionElements && sectionElements.length > 0 && sectionElements[0] != null) {
          return (
            <div key={group.title}>
              {headerGroup}
              {sectionElements}
            </div>
          );
        } else {
          return (
            <div key={group.title}></div>
          );
        }
      });

      return <div>{table}</div>;
    } else {
      return (
        <MSection className="m-2">
          <BoxDanger>Non sono presenti attività formative.</BoxDanger>
        </MSection>
      );
    }
  }
}
